
import { Injectable } from '@angular/core';
import { APPCONFIG } from '../_store/appConfig';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  appName = Object.freeze(APPCONFIG.appName);
  appConfig = Object.freeze(APPCONFIG);
  webActions = Object.freeze(APPCONFIG.webActions);
  urls = Object.freeze(APPCONFIG.urls);
  appVersion = Object.freeze(APPCONFIG.appVersion);
  deployDate = Object.freeze(APPCONFIG.deployDate);
  isProd = Object.freeze(APPCONFIG.environment_name === 'PROD');
  isQA = Object.freeze(APPCONFIG.environment_name === 'QA');
  appEvents = Object.freeze(APPCONFIG.appEvents);
  rolesData = Object.freeze(APPCONFIG.userRoles);
  roleNamesMapping = Object.freeze(APPCONFIG.userRolesNameMapping);

  constructor(
  ) {}

  getAppMenuItems(currentUser) {
    // Prefer a tenant-specific menu (set via ?app=<tenant>, e.g. jpm) and fall
    // back to the build-time appName when the tenant has no custom menu list.
    const tenant = sessionStorage.getItem('appName');
    const appMenuItems = (tenant && APPCONFIG.appMenuItems[tenant]) || APPCONFIG.appMenuItems[this.appName];
    const menuItems = APPCONFIG.menuItems;
    const userRole = currentUser.userRole || 1;
    return appMenuItems.filter(menuItem => {
      return menuItems[menuItem];
    }).map(menuItem => {
      const item = menuItems[menuItem];
      if (item.propToCheck) {
        if (currentUser[item.propToCheck]) {
          return item;
        } else {
          return;
        }
      }
      if (item.hideLinkProp) {
        if (currentUser[item.hideLinkProp]) {
          return;
        } else {
          return item;
        }
      }
      return item;
    }).filter(menuItem => {
      return (typeof menuItem !== 'undefined' && (typeof menuItem.roles === 'undefined' ? true : menuItem.roles.indexOf(userRole) !== -1));
    });
  }

  getVersionInfoStr() {
    const getString = (val) => {
      return val? `- ${val}` : '';
    }
    const versionInfoStr = `${APPCONFIG.appVersion} - ${APPCONFIG.environment_name}${getString(APPCONFIG.web_api_version)} - ${APPCONFIG.deployDate}`;
    return versionInfoStr;
  }

}
